import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Materials from '../components/Materials/Index';
import * as Actions from '../models/materials/actions';


const mapStateToProps = state => ({
    answer: state.materials
});


const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});


const MaterialsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Materials);

export default MaterialsContainer;



// WEBPACK FOOTER //
// ./src/containers/Materials.container.js